// extracted by mini-css-extract-plugin
module.exports = {"form":"form___1EeyS","disclaimer":"disclaimer___1NES1","error":"error___35jFt"};